import {
  GET_CATEGORY_LISTING,
  SET_CATEGORY_LISTING,
  GET_ADD_APP_PERMISSION,
  SET_ADD_APP_PERMISSION,
  GET_CHECK_APP_PERMISSION,
  SET_CHECK_APP_PERMISSION,
  GET_APPLICATION_LISTING,
  SET_APPLICATION_LISTING,
  GET_APP_AREA_LISTING,
  SET_APP_AREA_LISTING,
  GET_ACTIVE_CATEGORY,
  SET_ACTIVE_CATEGORY,
  GET_CHECK_CATEGORY,
  SET_CHECK_CATEGORY,
  SET_IS_CATEGORY_CHECK,
  GET_ADD_CATEGORY,
  SET_ADD_CATEGORY,
  SET_APP_PERMISSION_LISTING,
  GET_APP_PERMISSION_LISTING,
  GET_APP_PERMISSION_BY_ID,
  SET_APP_PERMISSION_BY_ID,
  GET_DELETE_APP_PERMISSION,
  SET_DELETE_APP_PERMISSION,
  GET_APP_AREA_CHECK,
  SET_APP_AREA_CHECK,
  GET_ADD_APP_AREA,
  SET_ADD_APP_AREA,
  SET_IS_APP_AREA_CHECK,
  GET_APP_AREA_BY_ID,
  SET_APP_AREA_BY_ID,
  GET_DELETE_APP_AREA,
  SET_DELETE_APP_AREA,
  GET_APPLICATION_CHECK,
  SET_APPLICATION_CHECK,
  SET_IS_APPLICATION_CHECK,
  GET_ADD_APPLICATION,
  SET_ADD_APPLICATION,
  GET_DELETE_CATEGORY,
  SET_DELETE_CATEGORY,
  GET_CATEGORY_BY_ID,
  SET_CATEGORY_BY_ID,
  GET_ACTIVE_APPLICATION,
  SET_ACTIVE_APPLICATION,
  GET_ACTIVE_APP_AREA,
  SET_ACTIVE_APP_AREA,
  SET_APPLICATION_BY_ID,
  GET_APPLICATION_BY_ID,
  GET_DELETE_APPLICATION,
  SET_DELETE_APPLICATION,
  SET_IS_CHECK,
  SET_IS_CHECK_APP_PER,
  GET_CREATE_USER,
  SET_CREATE_USER,
  GET_USER_GRID_DATA,
  SET_USER_GRID_DATA,
  GET_USER,
  SET_USER,
  UPDATE_CREATE_USER,
  GET_USER_UPN_DATA,
  SET_USER_UPN_DATA,
  GET_ADD_SECURITY_ROLE,
  SET_ADD_SECURITY_ROLE,
  GET_SECURITY_ROLE_BY_ID,
  SET_SECURITY_ROLE_BY_ID,
  GET_DELETE_SECURITY_ROLE,
  SET_DELETE_SECURITY_ROLE,
  GET_SECURITY_PERMISSION_LISTING,
  SET_SECURITY_PERMISSION_LISTING,
  GET_SECURITY_ROLE_LISTING,
  SET_SECURITY_ROLE_LISTING,
  GET_ACTIVE_ROLES,
  SET_ACTIVE_ROLES,
  GET_USER_DIVISIONS,
  SET_USER_DIVISIONS,
  GET_USER_COST_CENTER,
  SET_USER_COST_CENTER,
  GET_CHECK_USER,
  SET_CHECK_USER,
  SET_IS_USER_CHECK,
  GET_TIME_ZONE,
  SET_TIME_ZONE,
  UPLOAD_APPLICATION_ICON,
  SET_UPLOAD_APPLICATION_ICON
} from "./types";

export const GetAddAppPermission = (order: any) => {
  return {
    type: GET_ADD_APP_PERMISSION,
    order,
  };
};
export const SetAddAppPermission = (OrderResponse: any) => {
  return {
    type: SET_ADD_APP_PERMISSION,
    payload: OrderResponse,
  };
};

export const GetAddSecurityRole = (order: any) => {
  return {
    type: GET_ADD_SECURITY_ROLE,
    order,
  };
};
export const SetAddSecurityRole = (OrderResponse: any) => {
  return {
    type: SET_ADD_SECURITY_ROLE,
    payload: OrderResponse,
  };
};

export const GetCheckAppPermission = (val: any) => {
  return {
    type: GET_CHECK_APP_PERMISSION,
    val,
  };
};
export const SetCheckAppPermission = (checkAppPermission: any) => {
  return {
    type: SET_CHECK_APP_PERMISSION,
    payload: checkAppPermission,
  };
};

export const getApplicationList = () => {
  return {
    type: GET_APPLICATION_LISTING,
  };
};
export const setApplicationList = (value: any) => {
  return {
    type: SET_APPLICATION_LISTING,
    value,
  };
};

export const getAppAreaList = () => {
  return {
    type: GET_APP_AREA_LISTING,
  };
};
export const setAppAreaList = (value: any) => {
  return {
    type: SET_APP_AREA_LISTING,
    value,
  };
};
export const getCategoryList = () => {
  return {
    type: GET_CATEGORY_LISTING,
  };
};
export const setCategoryList = (value: any) => {
  return {
    type: SET_CATEGORY_LISTING,
    value,
  };
};

export const setIsCheckAppPer = (value: boolean) => {
  return {
    type: SET_IS_CHECK_APP_PER,
    value,
  };
};

export const getActiveCategory = () => {
  return {
    type: GET_ACTIVE_CATEGORY,
  };
};
export const SetActiveCategory = (activeCategoryData: any) => {
  return {
    type: SET_ACTIVE_CATEGORY,
    payload: activeCategoryData,
  };
};
export const getCheckCategory = (val: any) => {
  return {
    type: GET_CHECK_CATEGORY,
    val,
  };
};
export const setCheckCategory = (checkCategory: any) => {
  return {
    type: SET_CHECK_CATEGORY,
    payload: checkCategory,
  };
};
export const setIsCategoryCheck = (value: boolean) => {
  return {
    type: SET_IS_CATEGORY_CHECK,
    value,
  };
};
export const getCheckUser = (val: any) => {
  return {
    type: GET_CHECK_USER,
    val,
  };
};
export const setCheckUser = (checkUser: any) => {
  return {
    type: SET_CHECK_USER,
    payload: checkUser,
  };
};
export const setIsUserCheck = (value: boolean) => {
  return {
    type: SET_IS_USER_CHECK,
    value,
  };
};
export const setIsCheck = (value: any) => {
  return {
    type: SET_IS_CHECK,
    value,
  };
};
export const GetAddCategory = (order: any) => {
  return {
    type: GET_ADD_CATEGORY,
    order,
  };
};
export const SetAddCategory = (OrderResponse: any) => {
  return {
    type: SET_ADD_CATEGORY,
    payload: OrderResponse,
  };
};
export const getAppPermissionListing = (val: any) => {
  return {
    type: GET_APP_PERMISSION_LISTING,
    val,
  };
};
export const setAppPermissionListing = (appPermissionListing: any) => {
  return {
    type: SET_APP_PERMISSION_LISTING,
    payload: appPermissionListing,
  };
};
export const getAppPermissionById = (val: any) => {
  return {
    type: GET_APP_PERMISSION_BY_ID,
    val,
  };
};
export const setAppPermissionById = (appPermissionById: any) => {
  return {
    type: SET_APP_PERMISSION_BY_ID,
    payload: appPermissionById,
  };
};
export const getSecurityRoleById = (val: any) => {
  return {
    type: GET_SECURITY_ROLE_BY_ID,
    val,
  };
};
export const setSecurityRoleById = (securityRoleById: any) => {
  return {
    type: SET_SECURITY_ROLE_BY_ID,
    payload: securityRoleById,
  };
};
export const getDeleteAppPermission = (val: any) => {
  return {
    type: GET_DELETE_APP_PERMISSION,
    val,
  };
};
export const setDeleteAppPermission = (deleteResponse: any) => {
  return {
    type: SET_DELETE_APP_PERMISSION,
    payload: deleteResponse,
  };
};
export const getDeleteSecurityRole = (val: any) => {
  return {
    type: GET_DELETE_SECURITY_ROLE,
    val,
  };
};
export const setDeleteSecurityRole = (deleteResponse: any) => {
  return {
    type: SET_DELETE_SECURITY_ROLE,
    payload: deleteResponse,
  };
};
export const getCheckAppArea = (val: any) => {
  return {
    type: GET_APP_AREA_CHECK,
    val,
  };
};
export const setCheckAppArea = (checkAppArea: any) => {
  return {
    type: SET_APP_AREA_CHECK,
    payload: checkAppArea,
  };
};
export const setIsAppAreaCheck = (value: boolean) => {
  return {
    type: SET_IS_APP_AREA_CHECK,
    value,
  };
};
export const GetAddAppArea = (order: any) => {
  return {
    type: GET_ADD_APP_AREA,
    order,
  };
};
export const SetAddAppArea = (OrderResponse: any) => {
  return {
    type: SET_ADD_APP_AREA,
    payload: OrderResponse,
  };
};
export const getAppAreaById = (val: any) => {
  return {
    type: GET_APP_AREA_BY_ID,
    val,
  };
};
export const setAppAreaById = (appareaById: any) => {
  return {
    type: SET_APP_AREA_BY_ID,
    payload: appareaById,
  };
};
export const getDeleteAppArea = (val: any) => {
  return {
    type: GET_DELETE_APP_AREA,
    val,
  };
};
export const setDeleteAppArea = (deleteAppArea: any) => {
  return {
    type: SET_DELETE_APP_AREA,
    payload: deleteAppArea,
  };
};
export const getCheckApplication = (val: any) => {
  return {
    type: GET_APPLICATION_CHECK,
    val,
  };
};
export const setCheckApplication = (checkApplication: any) => {
  return {
    type: SET_APPLICATION_CHECK,
    payload: checkApplication,
  };
};
export const setIsApplicationCheck = (value: boolean) => {
  return {
    type: SET_IS_APPLICATION_CHECK,
    value,
  };
};
export const GetAddApplication = (order: any) => {
  return {
    type: GET_ADD_APPLICATION,
    order,
  };
};
export const SetAddApplication = (OrderResponse: any) => {
  return {
    type: SET_ADD_APPLICATION,
    payload: OrderResponse,
  };
};
export const getDeleteCategory = (val: any) => {
  return {
    type: GET_DELETE_CATEGORY,
    val,
  };
};
export const setDeleteCategory = (deleteResponse: any) => {
  return {
    type: SET_DELETE_CATEGORY,
    payload: deleteResponse,
  };
};
export const getCategoryById = (val: any) => {
  return {
    type: GET_CATEGORY_BY_ID,
    val,
  };
};
export const setCategoryById = (categoryById: any) => {
  return {
    type: SET_CATEGORY_BY_ID,
    payload: categoryById,
  };
};
export const getActiveApplication = () => {
  return {
    type: GET_ACTIVE_APPLICATION,
  };
};
export const SetActiveApplication = (activeApplicationData: any) => {
  return {
    type: SET_ACTIVE_APPLICATION,
    payload: activeApplicationData,
  };
};
export const getActiveAppArea = (val: any) => {
  return {
    type: GET_ACTIVE_APP_AREA,
    val,
  };
};
export const SetActiveAppArea = (activeAppAreaData: any) => {
  return {
    type: SET_ACTIVE_APP_AREA,
    payload: activeAppAreaData,
  };
};
export const getApplicationById = (val: any) => {
  return {
    type: GET_APPLICATION_BY_ID,
    val,
  };
};
export const setApplicationById = (appPermissionById: any) => {
  return {
    type: SET_APPLICATION_BY_ID,
    payload: appPermissionById,
  };
};
export const getDeleteApplication = (val: any) => {
  return {
    type: GET_DELETE_APPLICATION,
    val,
  };
};
export const setDeleteApplication = (deleteResponse: any) => {
  return {
    type: SET_DELETE_APPLICATION,
    payload: deleteResponse,
  };
};
export const createUser = (payload: any) => {
  return {
    type: GET_CREATE_USER,
    payload,
  };
};
export const SetCreateUser = (OrderResponse: any) => {
  return {
    type: SET_CREATE_USER,
    payload: OrderResponse,
  };
};
export const getUserGridData = (payload: any) => {
  return {
    type: GET_USER_GRID_DATA,
    payload
  };
};

export const setUserGridData = (payload: any) => {
  return {
    type: SET_USER_GRID_DATA,
    payload,
  };
};

export const getUser = (payload: any) => {
  return {
    type: GET_USER,
    payload,
  };
};

export const setUser = (payload: any) => {
  return {
    type: SET_USER,
    payload,
  };
};

export const updateUser = (payload: any) => {
  return {
    type: UPDATE_CREATE_USER,
    payload,
  };
};

export const getUserByUPN = (payload: any) => {
  return {
    type: GET_USER_UPN_DATA,
    payload,
  };
};

export const setUserByUPN = (payload: any) => {
  return {
    type: SET_USER_UPN_DATA,
    payload,
  };
};

export const getSecurityPermissionList = (val: any) => {
  return {
    type: GET_SECURITY_PERMISSION_LISTING,
    val,
  };
};
export const setSecurityPermissionList = (securityPermissionList: any) => {
  return {
    type: SET_SECURITY_PERMISSION_LISTING,
    payload: securityPermissionList,
  };
};

export const getSecurityRoleList = (val: any) => {
  return {
    type: GET_SECURITY_ROLE_LISTING,
    val,
  };
};
export const setSecurityRoleList = (securityRoleList: any) => {
  return {
    type: SET_SECURITY_ROLE_LISTING,
    payload: securityRoleList,
  };
};
export const getActiveRoles = (val: any) => {
  return {
    type: GET_ACTIVE_ROLES,
    val,
  };
};
export const SetActiveRoles = (activeRolesData: any) => {
  return {
    type: SET_ACTIVE_ROLES,
    payload: activeRolesData,
  };
};

export const getUserDivisions = () => {
  return {
    type: GET_USER_DIVISIONS,
  };
};

export const setUserDivisions = (payload: any) => {
  return {
    type: SET_USER_DIVISIONS,
    payload
  };
};

export const getUserCostCenter = (payload: any) => {
  return {
    type: GET_USER_COST_CENTER,
    payload
  };
};

export const setUserCostCenter = (payload: any) => {
  return {
    type: SET_USER_COST_CENTER,
    payload
  };
};

export const getTimeZone = () => {
  return {
    type: GET_TIME_ZONE,
  };
};
export const SetTimeZone = (timeZone: any) => {
  return {
    type: SET_TIME_ZONE,
    payload: timeZone,
  };
};

export const uploadApplicationIcon = (payload: any) => {
  return {
    type: UPLOAD_APPLICATION_ICON,
    payload
  };
};
export const setApplicationIcon = (response: any) => {
  return {
    type: SET_UPLOAD_APPLICATION_ICON,
    response
  };
};